import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

// Register font (optional, can be customized)
Font.register({
  family: "Times New Roman",
  src: "https://db.onlinewebfonts.com/t/32441506567156636049eb850b53f02a.ttf",
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Times-Roman",
  },
  header: {
    marginBottom: 10,
    textAlign: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#8c1d1a",
    marginBottom: 4,
  },
  ledgerInfo: {
    fontSize: 10,
    marginBottom: 8,
    textAlign: "center",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#8c1d1a",
    marginBottom: 8,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#8c1d1a",
    borderBottomStyle: "solid",
    width: "100%",
  },
  tableHeader: {
    backgroundColor: "#f0e6d2",
    fontWeight: "bold",
  },
  cellDate: {
    fontSize: 9,
    padding: 4,
    width: "15%",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  cellType: {
    fontSize: 9,
    padding: 4,
    width: "18%",
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
  },
  cellCredit: {
    fontSize: 9,
    padding: 4,
    width: "15%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f5ea",
    color: "#000",
  },
  cellDebit: {
    fontSize: 9,
    padding: 4,
    width: "15%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#fce8ea",
    color: "#000",
  },
  cellBalance: {
    fontSize: 9,
    padding: 4,
    width: "15%",
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#e8f4f7",
    color: "#000",
  },
  cellRemarks: {
    fontSize: 9,
    padding: 4,
    width: "22%",
    textAlign: "left",
    borderRightWidth: 0,
  },
  headerCell: {
    fontSize: 10,
    fontWeight: "bold",
    padding: 4,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#8c1d1a",
    borderRightStyle: "solid",
    backgroundColor: "#f0e6d2",
  },
  headerCellLast: {
    fontSize: 10,
    fontWeight: "bold",
    padding: 4,
    textAlign: "center",
    borderRightWidth: 0,
    backgroundColor: "#f0e6d2",
  },
  footer: {
    marginTop: 16,
    fontSize: 9,
    textAlign: "center",
  },
});

const BankLedgerPDF = ({
  ledgerData = [],
  bankInfo = {},
  fromDate = "",
  toDate = "",
  entireReport = false,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
    } catch (error) {
      return dateString;
    }
  };

  const formatCurrency = (value) => {
    if (!value || value === 0) return "-";
    return `₹ ${parseFloat(value).toFixed(2)}`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Bank Ledger</Text>
          <Text style={styles.ledgerInfo}>
            Bank: {bankInfo?.bankName || bankInfo?.label || "N/A"}
          </Text>
          {bankInfo?.accountHolder && (
            <Text style={styles.ledgerInfo}>
              Account Holder: {bankInfo.accountHolder}
            </Text>
          )}
          {bankInfo?.accountNumber && (
            <Text style={styles.ledgerInfo}>
              Account Number: {bankInfo.accountNumber}
            </Text>
          )}
          <Text style={styles.ledgerInfo}>
            {entireReport
              ? "Entire Report"
              : `From: ${fromDate ? formatDate(fromDate) : "Beginning"} To: ${
                  toDate ? formatDate(toDate) : "Today"
                }`}
          </Text>
        </View>

        {/* Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.headerCell, { width: "15%" }]}>DATE</Text>
            <Text style={[styles.headerCell, { width: "18%" }]}>TYPE</Text>
            <Text style={[styles.headerCell, { width: "15%" }]}>CREDIT</Text>
            <Text style={[styles.headerCell, { width: "15%" }]}>DEBIT</Text>
            <Text style={[styles.headerCell, { width: "15%" }]}>BALANCE</Text>
            <Text style={[styles.headerCellLast, { width: "22%" }]}>
              REMARKS
            </Text>
          </View>

          {/* Table Body */}
          {ledgerData.map((row, idx) => (
            <View key={idx} style={styles.tableRow}>
              <Text style={styles.cellDate}>{formatDate(row.date)}</Text>
              <Text style={styles.cellType}>{row.type || "-"}</Text>
              <Text style={styles.cellCredit}>{row.credit || "-"}</Text>
              <Text style={styles.cellDebit}>{row.debit || "-"}</Text>
              <Text style={styles.cellBalance}>{row.balance || "-"}</Text>
              <Text style={styles.cellRemarks}>{row.remarks || "-"}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default BankLedgerPDF;
